import { RELOAD_PAGE_NOTIFICATION } from '../constants/serviceMessage';
var restartMiddleware = function (store) { return function (next) { return function (action) {
    if (action.type == RELOAD_PAGE_NOTIFICATION) {
        window.location.reload();
    }
    else {
        next(action);
    }
}; }; };
export default restartMiddleware;



//////////////////
// WEBPACK FOOTER
// ./src/middleware/restart.ts
// module id = 866
// module chunks = 0